<template>
  <div class="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200">
    <div class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-space-y-0 tw-pb-2 tw-p-6">
      <div class="tw-flex tw-items-center tw-gap-2">
        <FolderOpen class="tw-w-5 tw-h-5 tw-text-gray-600" />
        <h3 class="tw-text-lg tw-font-semibold tw-text-gray-900">
          {{ t('customer_management.titles.main_info') }}
        </h3>
      </div>
    </div>

    <div class="tw-px-6 tw-pb-6">
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
        <div class="tw-space-y-4">
          <div>
            <label class="tw-text-sm tw-text-gray-600">
              {{ t('customer_management.forms.name') }}
            </label>
            <p class="tw-mt-1 tw-text-gray-900 tw-text-sm tw-font-bold">
              {{ customer.name || '--' }}
            </p>
          </div>
          <div>
            <label class="tw-text-sm tw-text-gray-600">
              {{ t('customer_management.forms.legal_name') }}
            </label>
            <p class="tw-mt-1 tw-text-gray-900 tw-text-sm tw-font-bold">
              {{ customer.legal_name || '--' }}
            </p>
          </div>
          <div>
            <label class="tw-text-sm tw-text-gray-600">
              {{ t('customer_management.main_data.available_limit') }}
            </label>
            <p class="tw-mt-1 tw-text-gray-900 tw-text-sm tw-font-bold">
              {{ customer.customer_limit || '--' }}
            </p>
          </div>
          <div>
            <label class="tw-text-sm tw-text-gray-600">
              {{ t('customer_management.assign_team.auto_approval_limit') }}
            </label>
            <p class="tw-mt-1 tw-text-gray-900 tw-text-sm tw-font-bold">
              {{ customer.auto_approval_limit || '--' }}
            </p>
          </div>
          <div>
            <label class="tw-text-sm tw-text-gray-600">
              {{ t('customer_management.main_data.financial_limit_frequency') }}
            </label>
            <p class="tw-mt-1 tw-text-gray-900 tw-capitalize tw-text-sm tw-font-bold">
              {{ customer.financial_limit_frequency || '--' }}
            </p>
          </div>
        </div>

        <div class="tw-space-y-4">
          <div>
            <label class="tw-text-sm tw-text-gray-600">
              {{ t('customer_management.main_data.address') }}
            </label>
            <p class="tw-mt-1 tw-text-gray-900 tw-text-sm tw-font-bold">
              {{ customer.address || '--' }}
            </p>
          </div>
          <div>
            <label class="tw-text-sm tw-text-gray-600">
              {{ t('common.titles.email') }}
            </label>
            <p class="tw-mt-1 tw-text-gray-900 tw-text-sm tw-font-bold">
              {{ customer.email || '--' }}
            </p>
          </div>
          <div>
            <label class="tw-text-sm tw-text-gray-600">
              {{ t('customer_management.forms.phone') }}
            </label>
            <p class="tw-mt-1 tw-text-gray-900 tw-text-sm tw-font-bold">
              {{ customer.phone_number || '--' }}
            </p>
          </div>
          <div>
            <label class="tw-text-sm tw-text-gray-600">Created On</label>
            <p class="tw-mt-1 tw-text-gray-900 tw-text-sm tw-font-bold">
              {{ customer.created_on || '--' }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FolderOpen } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

interface Customer {
  name?: string;
  legal_name?: string;
  customer_limit?: string | number;
  auto_approval_limit?: string | number;
  financial_limit_frequency?: string;
  address?: string;
  email?: string;
  phone_number?: string;
  is_restricted?: boolean;
  created_on?: string;
}

interface Props {
  customer: Customer;
}
defineProps<Props>();

const { t } = useI18n();
</script>
